export { default as Squares } from "./squares";
export { default as ProjectCard } from "./project-card";
